import React, { useState } from 'react';
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import { IDocumentLoader } from './types/document';
import { ButtonComponent } from '@syncfusion/ej2-react-buttons';
import moment from 'moment';

interface AboutDialogProps {
    documentLoader: IDocumentLoader;
}

function formatBytes(bytes: number, decimals = 2) : any {
    if (!+bytes) return '0 Bytes'

    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

    const i = Math.floor(Math.log(bytes) / Math.log(k))

    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
}

function AboutDocumentDialog(props: AboutDialogProps) {

    const [ showAboutDialog, setShowAboutDialog ] = useState <boolean>(false);

    return (
        <React.Fragment>
            <ButtonComponent 
                ref={(denseBtn: any) => (denseBtn = denseBtn)} 
                //ref={(scope) => { btn = scope as ButtonComponent; }
                aria-label='menu' 
                cssClass='e-inherit menu' 
                iconCss='e-icons e-menu' 
                onClick={() => setShowAboutDialog(true)}
            ></ButtonComponent>
            {showAboutDialog && 
                <DialogComponent 
                    width='400px' 
                    target='#editorContainerElement' 
                    showCloseIcon={true} 
                    header="Інформація щодо документу"
                    position={{ X: 'center', Y: 'center' }}
                    closeOnEscape={false}
                    close={() => setShowAboutDialog(false)}
                >
                    <ul>
                        <li>Назва документа: <strong>{props.documentLoader.document.name}</strong></li>
                        <li>Версія документа: <strong>{props.documentLoader.document.metadata.versionNumber}</strong></li>
                        <li>Назва файлу: <strong>{props.documentLoader.document.metadata.file.name}</strong></li>
                        <li>Тип файлу: <strong>{props.documentLoader.document.metadata.documentType}</strong></li>
                        <li>Розмір файлу: <strong>{formatBytes(props.documentLoader.document.metadata.file.size)}</strong></li>
                        <li>Створено: <strong>{moment(props.documentLoader.document.metadata.creationDate).format('DD.MM.YYYY HH:mm')}</strong></li>
                    </ul> 
                </DialogComponent>
            }
        </React.Fragment>
    );
}
export default AboutDocumentDialog;